import React from 'react';

interface ReviewData {
  category: string;
  objective: string;
  businessName: string;
  websiteUrl: string;
  campaignName: string;
  facebookPage: string;
  dailyBudget: string;
  keywords: string[];
  locations: string;
  offeredProductsServices: string;
  competitiveAdvantages: string;
  offers: string;
  serviceDescription: string;
  creativeImages: string[];
  creativeVideos: string[];
  creativeVideoThumbnails: string[];
}

const objectives = [
  { name: 'Sales', icon: '🛒', objective: 'OUTCOME_SALES' },
  { name: 'Leads', icon: '📈', objective: 'OUTCOME_LEADS' },
  { name: 'Brand Awareness', icon: '🎯', objective: 'OUTCOME_AWARENESS' },
  { name: 'Engagement', icon: '🤝', objective: 'OUTCOME_ENGAGEMENT' },
  { name: 'Traffic', icon: '🚦', objective: 'OUTCOME_TRAFFIC' },
  { name: 'App Promotion', icon: '📱', objective: 'OUTCOME_APP_PROMOTION' },
];

const ReviewLaunch: React.FC<{ data: ReviewData }> = ({ data }) => {
  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-8">
          Review & Launch
        </h2>
        <div className="space-y-8">
          {/* First Row: Campaign Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Campaign Category */}
            {/* <div>
              <p className="text-sm font-semibold text-black mb-1">Campaign Category</p>
              <p className="text-base text-gray-600">{data.category}</p>
            </div> */}

            {/* Campaign Objective */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Campaign Objective</p>
              <p className="text-base text-gray-600">
                {objectives.find(obj => obj.objective === data.objective)?.name || data.objective}
              </p>
            </div>

            {/* Business Name */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Business Name</p>
              <p className="text-base text-gray-600">{data.businessName}</p>
            </div>

            {/* Website URL */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Website URL</p>
              <p className="text-base text-gray-600">{data.websiteUrl}</p>
            </div>

            {/* Campaign Name */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Campaign Name</p>
              <p className="text-base text-gray-600">{data.campaignName}</p>
            </div>

            {/* Facebook Page */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Facebook Page</p>
              <p className="text-base text-gray-600">{data.facebookPage}</p>
            </div>

            {/* Daily Budget */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Daily Budget</p>
              <p className="text-base text-gray-600">{data.dailyBudget}</p>
            </div>
          </div>

          {/* Second Row: Keywords and Locations */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Keywords */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">
                Keywords that refer to your target audience
              </p>
              <p className="text-base text-gray-600">{data.keywords.join(', ')}</p>
            </div>

            {/* Locations */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">
                Location(s) within your city you want to target
              </p>
              <p className="text-base text-gray-600">{data.locations}</p>
            </div>
          </div>

          {/* Third Row: Products, Advantages, Offers, and Description */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Offered Products/Services */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Offered Products/Services</p>
              <p className="text-base text-gray-600">{data.offeredProductsServices}</p>
            </div>

            {/* Competitive Advantages */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Competitive Advantages</p>
              <p className="text-base text-gray-600">{data.competitiveAdvantages}</p>
            </div>

            {/* Offers */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Offers</p>
              <p className="text-base text-gray-600">{data.offers}</p>
            </div>

            {/* Service Description */}
            <div>
              <p className="text-sm font-semibold text-black mb-1">Service Description</p>
              <p className="text-base text-gray-600">{data.serviceDescription}</p>
            </div>
          </div>

          {/* Fourth Row: Creative Images */}
          <div>
            <p className="text-sm font-semibold text-black mb-1">Creative Images</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {data.creativeImages.map((image, index) => (
                <div
                  key={index}
                  className="relative rounded-lg overflow-hidden border border-gray-300"
                >
                  <img
                    src={image}
                    alt={`Creative ${index + 1}`}
                    className="w-full h-40 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Fifth Row: Creative Videos */}

          {/* Fifth Row: Creative Videos */}
          {data.creativeVideos.length > 0 && (
            <div>
              <p className="text-sm font-semibold text-black mb-1">Creative Videos</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {data.creativeVideoThumbnails.map((thumbnail, index) => (
                  <div
                    key={index}
                    className="relative rounded-lg overflow-hidden border border-gray-300"
                  >
                    <img
                      src={thumbnail}
                      alt={`Creative Video ${index + 1}`}
                      className="w-full h-40 object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewLaunch;
